import type { MouseEventHandler } from 'react'
import { useCallback, useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import ModalContext from 'contexts/ModalContext'
import LoyaltyTierStayUpgradeMessageBanner from 'loyalty/components/LoyaltyTierStayUpgradeMessageBanner'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import TierProgressionInfoModal from './TierProgressionInfoModal'
import TextLink from 'LuxKit/TextLink'

interface Props {
  highestUnlockableTier: App.LoyaltyTier
  highestUnlockableTierName: string
  onBookNow?: () => void
  onAddToCart?: () => void
  checkoutDate?: string
}

function RateTierProgressionCallOutBanner({
  highestUnlockableTier,
  highestUnlockableTierName,
  onBookNow,
  onAddToCart,
  checkoutDate,
}: Props) {
  const showModal = useContext(ModalContext)
  const programName = getLoyaltyProgramDisplayName()

  const handleOpenModal = useCallback<MouseEventHandler>((event) => {
    event.preventDefault()
    showModal(<TierProgressionInfoModal
      tiers={[highestUnlockableTier]}
      onBookNow={onBookNow}
      onAddToCart={onAddToCart}
      checkoutDate={checkoutDate}
    />)
  }, [showModal, highestUnlockableTier, onBookNow, onAddToCart, checkoutDate])

  return (
    <LoyaltyTierStayUpgradeMessageBanner tier={highestUnlockableTier}>
      {/* Message and link share one wrapper so the banner's flex row keeps them on the same line. */}
      <span>
        <b>
          <FormattedMessage
            id="pMnj-Iw5AcfsWmT5EwEz"
            defaultMessage="Unlock {tierName} {programName} status when you book this package"
            
            values={{ tierName: highestUnlockableTierName, programName }}
          />
        </b> <TextLink weight="regular" size="medium" underline onClick={handleOpenModal}>
          <FormattedMessage
            id="47I-Dg-m-UnGF5JPVVdV"
            defaultMessage="Learn more"
            
          />
        </TextLink>
      </span>
    </LoyaltyTierStayUpgradeMessageBanner>
  )
}

export default RateTierProgressionCallOutBanner
